var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PageLogin"},[_c('v-toolbar-title',[_vm._v("Fazer Login")]),_c('form-login')],1)}
var staticRenderFns = []

export { render, staticRenderFns }